module.exports={
	"Form": "RoleEdgeEditManifest",
	"Scope": "RoleEdge-Edit",
	"Descriptors":
	{
		"RoleEdgeDetails.IDRoleEdge":
		{
			"Name": "ID",
			"Hash": "RoleEdgeEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "RoleEdgeEditIdentity",
				"Group": "RoleEdgeEditIdentity"
			}
		},
		"RoleEdgeDetails.GUIDRoleEdge":
		{
			"Name": "GUID",
			"Hash": "RoleEdgeEdit-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "RoleEdgeEditIdentity",
				"Group": "RoleEdgeEditIdentity"
			}
		},
		"RoleEdgeDetails.ParentIDRole":
		{
			"Name": "Parent Role ID",
			"Hash": "RoleEdgeEdit-ParentIDRole",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "1",
				"Width": 3,
				"Section": "RoleEdgeEditIdentity",
				"Group": "RoleEdgeEditIdentity"
			}
		},
		"RoleEdgeDetails.ChildIDRole":
		{
			"Name": "Child Role ID",
			"Hash": "RoleEdgeEdit-ChildIDRole",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "1",
				"Width": 3,
				"Section": "RoleEdgeEditIdentity",
				"Group": "RoleEdgeEditIdentity"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Role Hierarchy",
			"Hash": "RoleEdgeEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Role Hierarchy",
					"Hash": "RoleEdgeEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
